'use strict';
module.exports = function (arr) {
	if (!Array.isArray(arr)) {
		throw new TypeError('Expected an array');
	}

	return arr[Math.floor(Math.random() * arr.length)];
};



//////////////////
// WEBPACK FOOTER
// ./~/random-item/index.js
// module id = 207
// module chunks = 0